import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Form, Modal, ColorPicker, Select } from "antd";
import MapShapeSelectionOptions from "./MapShapeSelectionOptions";
const GeographicAreaShapePickerModal = ({ open, onOk, onCancel }) => {
    const [form] = Form.useForm();
    useEffect(() => {
        if (open) {
            form.resetFields();
        }
    }, [open]);
    const onFinish = (formValues) => {
        const shapeOption = MapShapeSelectionOptions.fromString(formValues.shape);
        if (onOk && shapeOption) {
            onOk(shapeOption, formValues.colourHex.toHexString());
        }
    };
    return (_jsx(Modal, { title: "New delivery area shape and colour", open: open, onOk: () => form.submit(), onCancel: onCancel, destroyOnHidden: true, children: _jsxs(Form, { layout: "vertical", form: form, onFinish: onFinish, children: [_jsx(Form.Item, { label: "Shape", name: "shape", rules: [
                        { required: true, message: 'Shape is required' },
                    ], children: _jsx(Select, { options: MapShapeSelectionOptions.selectOptions() }) }), _jsx(Form.Item, { label: "Colour", name: "colourHex", rules: [
                        { required: true, message: 'Colour is required' },
                    ], children: _jsx(ColorPicker, { showText: true, disabledAlpha: true }) })] }) }));
};
export default GeographicAreaShapePickerModal;
